import React from "react"
import Skeleton from "react-loading-skeleton"
import {MainSection} from "../../../containers/MainSection/MainSection"
import {LimitsPageBlockHeader, LimitsPageDescription} from "./LimitsPageBlockHeader"

export function AccountLimitsPagePending() {
	return (
		<MainSection>
			<div className="account-limits-page">
				<div className="account-limits-page-header">
					<div>
						<h2 className="account-limits-page-title">Account Limits</h2>
						<LimitsPageDescription />
					</div>
				</div>

				<div className="account-limits-page-section">
					<LimitsPageBlockHeader title="Card Limits" icon="credit-card-money-fund--business-products" />
					<div className="account-limits-page-grid">
						{[1, 2, 3, 4].map((i) => (
							<div key={i} className="account-limits-page-range-box-skeleton">
								<Skeleton height={100} />
							</div>
						))}
					</div>
				</div>

				<div className="account-limits-page-section">
					<LimitsPageBlockHeader title="Originated ACH Payments Limits" icon="money-transfer--business-products" />
					<div className="account-limits-page-grid">
						{[1, 2, 3, 4].map((i) => (
							<div key={i} className="account-limits-page-range-box-skeleton">
								<Skeleton height={100} />
							</div>
						))}
					</div>
				</div>

				<div className="account-limits-page-section">
					<LimitsPageBlockHeader title="Check Deposit Limits" icon="check-write--business-products" />
					<div className="account-limits-page-grid">
						{[1, 2].map((i) => (
							<div key={i} className="account-limits-page-range-box-skeleton">
								<Skeleton height={100} />
							</div>
						))}
					</div>
				</div>

				<div className="account-limits-page-section">
					<LimitsPageBlockHeader title="Check Payment Limits" icon="check-write--business-products" />
					<div className="account-limits-page-grid">
						{[1, 2].map((i) => (
							<div key={i} className="account-limits-page-range-box-skeleton">
								<Skeleton height={100} />
							</div>
						))}
					</div>
				</div>

				<div className="account-limits-page-section">
					<LimitsPageBlockHeader title="Wire Limits" icon="money-transfer--business-products" />
					<div className="account-limits-page-grid">
						{[1, 2].map((i) => (
							<div key={i} className="account-limits-page-range-box-skeleton">
								<Skeleton height={100} />
							</div>
						))}
					</div>
				</div>
			</div>
		</MainSection>
	)
}
